import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import React, { useContext } from "react";

export const CollectiveProductContext = React.createContext<Array<ProductContextModel>>([]);

export const useCollectiveProductContext = () => {
    return useContext(CollectiveProductContext);
};
